class DotoPaymentSummary extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-doto-payment-summary-text]');
    this.sectionId = this.getAttribute('section-id');
    this.scope = this.sectionId ? document.getElementById(`shopify-section-${this.sectionId}`) : this.closest('[id^="shopify-section-"]');
    this.scope ||= document;

    this.update = this.update.bind(this);
    this.update();

    this.observer = new MutationObserver(this.update);
    this.observer.observe(this.scope, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  update() {
    if (!this.output) return;

    const msiText = this.scope.querySelector('[id^="textoFinal-tarjetaMSI-"]')?.textContent?.trim();
    const mciText = this.scope.querySelector('[id^="textoFinalMCI-"]')?.textContent?.trim();
    const nextText = msiText || mciText || '';

    if (this.output.textContent !== nextText) {
      this.output.textContent = nextText;
    }

    this.hidden = !nextText;
  }
}

if (!customElements.get('doto-payment-summary')) {
  customElements.define('doto-payment-summary', DotoPaymentSummary);
}
